import { IModelOptionType } from '../../types'
import { enumTransformer } from '../../../services/_common/utils'
import {TApiEnums} from '../../../services/_common'

export function parseModelOptionTypes(response: TApiEnums): IModelOptionType[] {
    return response.entities.map(enumTransformer)
}